import { render } from "./Turmas.vue?vue&type=template&id=c71d0a0c&scoped=true"
import script from "./Turmas.vue?vue&type=script&lang=js"
export * from "./Turmas.vue?vue&type=script&lang=js"

import "./Turmas.vue?vue&type=style&index=0&id=c71d0a0c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c71d0a0c"]])

export default __exports__